<div class="form-group">
  @if (showLabel && (question?.question_copy || question?.email_version || labelText)) {
    <label
      [innerHtml]="question?.question_copy || question?.email_version || labelText"
      class="form-group__label">
    </label>
  }

  <div class="row row--xxs">
    <div class="col col-sm-3">
      <div class="form-group mb-0">
        <input type="text" [(ngModel)]="birthDate" placeholder="DD" (ngModelChange)="inputChange()" class="form-control"
          mask="00"
          [showMaskTyped]="false"
          placeHolderCharacter="D"
          [disabled]="readOnly"
          >
        </div>
      </div>

      <div class="col col-5 col-sm">
        <div class="form-group mb-0">
          <app-question-dropdown
            [labelText]="'Month'"
            [showLabel]="false"
            [showOptionLabel]="true"
            [options]="months"
            [controlCssClass]="' '"
            [selectedValue]="birthMonth"
            [readOnly]="readOnly"
            (questionAnswer)="dropdownChange($event)">
          </app-question-dropdown>
        </div>
      </div>

      <div class="col col-4 col-sm-3">
        <div class="form-group mb-0">
          <input
            type="text"
            placeholder="YYYY"
            [(ngModel)]="birthYear"
            (ngModelChange)="inputChange()"
            class="form-control"
            mask="0000"
            [showMaskTyped]="false"
            placeHolderCharacter="Y"
            [disabled]="readOnly">
          </div>
        </div>
      </div>
    </div>